/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".start-buttons-block[_ngcontent-%COMP%]{display:block;height:100%;align-items:center}.start-buttons-block[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:100%;min-height:48px;background-color:#c4c4c4;border:none;font-family:Ubuntu;font-size:16px;line-height:41px;text-align:center;letter-spacing:.41px;margin-bottom:24px}"];
export { styles as styles };
